import { AlleleFormat, KitClient, LabClient, LabKitClient } from "@app/api2/api";
import { useEffect, useState } from "react";
import { SelectableItem, SelectableItemTyped, useSelectableList } from "./UseSelectableList";
import { useUser } from "../Contexts/UserContext";
import { queriesClient } from "@app/api2/Clients";
import { toAlleleFormatName } from "@common/AlleleFormatNames";


export function useAlleleFormats() {
  const alleleFormats = useSelectableList<SelectableItemTyped<AlleleFormat>, AlleleFormat>({
    apiCall: () => queriesClient.getEnabledAlleleFormats().then(response => response.map(format => ({ id: format, value: format, text: toAlleleFormatName(format) }))),
  });

  return alleleFormats;
}